<template>
    <Portal to="sidepanel">
        <SidePanel
            key="addPaymentMethodSidePanel"
            class="add-payment-method"
            name="Add Card"
            width="medium"
            :disable-transition="props.disableTransition"
            :class="{ 'add-payment-method--full-height': props.showFullHeight }"
            :isTeachSidePanel="true"
            :showCancelButton="false"
            @close="emitClose"
        >
            <div class="add-payment-method__shipping-address-text">
                Shipping address is solely for tax purposes.
            </div>
            <PaymentFields
                mode="setup"
                @paymentMethodSaved="addPaymentMethod"
                @close="emitClose"
            />
        </SidePanel>
    </Portal>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import UIKit from '@pocketprep/ui-kit'
import PaymentFields from '@/components/PaymentFields.vue'
import { stripeModule } from '@/store/stripe/module'
import { toastModule } from '@/store/toast/module'

const {
    SidePanel,
} = UIKit

const props = withDefaults(
    defineProps<{
        disableTransition?: boolean
        showFullHeight?: boolean
    }>(),
    {
        disableTransition: false,
        showFullHeight: false,
    }
)

const emit = defineEmits<{
    close: [value?: boolean]
    error: []
}>()

const isLoading = ref(false)

const emitClose = () => {
    emit('close', true)
}

const addPaymentMethod = async () => {
    isLoading.value = true
    if (import.meta.env.VUE_APP_STRIPE_PUBLISHABLE_KEY) {
        await stripeModule.actions.loadNewPaymentMethods()
        toastModule.actions.displayToast({
            title: 'Card added.',
        })
        emitClose()
    }
    isLoading.value = false
}
</script>

<style lang="scss" scoped>
.add-payment-method {
    &--full-height {
        top: 0;
        height: 100%;
    }

    &__license-code {
        margin-bottom: 29px;
        padding: 0;
    }

    &__shipping-address-text {
        font-size: 14px;
        font-weight: 500;
        color: $ash;
        margin-bottom: 36px;
        margin-left: 18px;
    }

    :deep(.uikit-side-panel__content) {
        padding: 36px 26px;
    }

    :deep(.uikit-side-panel__foot) {
        display: none;
    }

    iframe[name="embedded-checkout"] {
        border-radius: 12px;
    }
}
</style>
